/* Creative Objekt — commerce behaviour: brief forms, product prefill, mobile sticky add-to-bag. */
(() => {
  /* ---------- Custom brief forms (homepage + contact page) ---------- */
  const setupDimensions = (fieldset) => {
    const addButton = fieldset.querySelector('[data-co-dim-add]');
    const template = fieldset.querySelector('[data-co-dim-row]');
    if (!addButton || !template) return;
    const blank = template.cloneNode(true);

    const renumber = () => {
      const rows = fieldset.querySelectorAll('[data-co-dim-row]');
      rows.forEach((row, i) => {
        const n = i + 1;
        const index = row.querySelector('.co-dimension-row__index');
        if (index) index.textContent = String(n).padStart(2, '0');
        row.querySelectorAll('input, select').forEach((field) => {
          field.name = field.name.replace(/Dimension \d+/, `Dimension ${n}`);
          const label = field.getAttribute('aria-label');
          if (label) field.setAttribute('aria-label', label.replace(/Dimension \d+/, `Dimension ${n}`));
        });
        const remove = row.querySelector('[data-co-dim-remove]');
        if (remove) {
          remove.hidden = rows.length === 1;
          remove.setAttribute('aria-label', `Remove dimension ${n}`);
        }
      });
    };

    addButton.addEventListener('click', () => {
      const row = blank.cloneNode(true);
      row.querySelectorAll('input').forEach((field) => { field.value = ''; });
      row.querySelectorAll('select').forEach((field) => { field.selectedIndex = 0; });
      row.setAttribute('data-co-row-entering', '');
      fieldset.insertBefore(row, addButton);
      renumber();
      const first = row.querySelector('input');
      if (first) first.focus();
    });

    fieldset.addEventListener('click', (event) => {
      const remove = event.target.closest('[data-co-dim-remove]');
      if (!remove) return;
      const row = remove.closest('[data-co-dim-row]');
      if (row && fieldset.querySelectorAll('[data-co-dim-row]').length > 1) {
        row.remove();
        renumber();
        addButton.focus();
      }
    });

    renumber();
  };

  /* Pre-fill the brief when arriving from a product ("?product=Title"). */
  const prefillFromProduct = () => {
    let product;
    try { product = new URLSearchParams(window.location.search).get('product'); } catch (e) { return; }
    if (!product) return;
    product = product.slice(0, 140);
    document.querySelectorAll('form[action*="/contact"]').forEach((form) => {
      if (!form.querySelector('[data-co-dims]')) return;
      if (!form.querySelector('input[name="contact[Product]"]')) {
        const hidden = document.createElement('input');
        hidden.type = 'hidden';
        hidden.name = 'contact[Product]';
        hidden.value = product;
        form.prepend(hidden);
        const note = document.createElement('p');
        note.className = 'co-brief-prefill';
        note.textContent = `Custom version of: ${product}`;
        const dims = form.querySelector('[data-co-dims]');
        dims.parentNode.insertBefore(note, dims);
      }
      const details = form.querySelector('textarea');
      if (details && !details.value.trim()) details.value = `I'd like a custom version of "${product}".\n`;
    });
  };

  /* ---------- Mobile sticky add-to-bag ---------- */
  const setupStickyAtc = () => {
    const bar = document.querySelector('[data-co-sticky-atc]');
    if (!bar) return;
    const sectionId = bar.dataset.section;
    const mainButton = document.getElementById(`ProductSubmitButton-${sectionId}`) || document.querySelector('.product-form__submit');
    if (!mainButton) return;
    const stickyButton = bar.querySelector('[data-co-sticky-button]');
    const price = bar.querySelector('[data-co-sticky-price]');
    bar.hidden = false;

    const sync = () => {
      const label = mainButton.querySelector('span');
      stickyButton.disabled = mainButton.disabled || mainButton.getAttribute('aria-disabled') === 'true';
      stickyButton.textContent = stickyButton.disabled && label ? label.textContent.trim() : 'Add to cart';
      const priceRoot = document.getElementById(`price-${sectionId}`);
      const mainPrice = priceRoot && (priceRoot.querySelector('.price--on-sale .price-item--last') || priceRoot.querySelector('.price__regular .price-item--regular'));
      if (mainPrice && price) price.textContent = mainPrice.textContent.trim();
    };
    sync();
    new MutationObserver(sync).observe(mainButton, { attributes: true, childList: true, subtree: true });
    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') subscribe(PUB_SUB_EVENTS.variantChange, () => window.setTimeout(sync, 50));

    stickyButton.addEventListener('click', () => {
      if (stickyButton.disabled) return;
      const current = document.getElementById(`ProductSubmitButton-${sectionId}`) || mainButton;
      current.click();
    });

    // Show the bar once the real buy button has scrolled above the viewport. A scroll check (not an
    // IntersectionObserver) so fast flicks and jump links that skip straight past the button still work.
    let ticking = false;
    const update = () => {
      ticking = false;
      const current = document.getElementById(`ProductSubmitButton-${sectionId}`) || mainButton;
      bar.classList.toggle('is-visible', current.getBoundingClientRect().bottom < 0);
    };
    window.addEventListener('scroll', () => { if (!ticking) { ticking = true; window.requestAnimationFrame(update); } }, { passive: true });
    window.addEventListener('resize', update);
    update();
  };

  const init = () => {
    document.querySelectorAll('[data-co-dims]').forEach(setupDimensions);
    prefillFromProduct();
    setupStickyAtc();
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
